import EventFallback from '../../../lib/events_fallback';
import UserSessionModal from './user_session_modal.js';

export default class UserSession extends EventFallback {
  constructor(...args) {
    super(...args);

    this.updateTime();

    if (window.userSession === undefined) {
      window.userSession = window.setInterval(() => {
        this.checkExpiration();
      }, 2000);
    }

    if (typeof window.checkUserActivity === 'undefined') {
      let checkActivityInterval = 60 * 1000;

      window.checkUserActivity = window.setInterval(() => {
        this.checkUserActivity();
      }, checkActivityInterval);
    }

    document.addEventListener(
      'turbolinks:load',
      this.monitorUserActivity.bind(this),
    );
  }

  get opts() {
    return {
      expiryTime: 30 * 60 * 1000 - 2 * 1000,
      expiryWarningInterval: 2 * 60 * 1000,
    };
  }

  shouldDisplayModal() {
    return (
      $('#main-content').data('controller') != 'EdgeTokens' &&
      $('#main-content').data('action') != 'monitor'
    );
  }

  monitorUserActivity() {
    $('body').on('click', () => {
      this.userActivityDetected();
    });
  }

  userActivityDetected() {
    this.screenClicked = true;
  }

  checkUserActivity() {
    if (this.screenClicked) {
      this.screenClicked = false;
      $.ajax({
        url: '/noop',
      })
        .done(
          function () {
            this.updateTime();
          }.bind(this),
        )
        .fail(function () {
          console.log('Refresh session failed!');
        });
    }
  }

  updateTime() {
    var now = Date.now();

    window.localStorage.setItem('user-session', now + this.opts.expiryTime);
    window.localStorage.setItem(
      'user-session-warning',
      now + (this.opts.expiryTime - this.opts.expiryWarningInterval),
    );
  }

  checkExpiration() {
    var currentExpiration = parseInt(
      window.localStorage.getItem('user-session-warning'),
    );

    if (isNaN(currentExpiration) || parseInt(Date.now()) > currentExpiration) {
      this.showModal();
    }
  }

  getSessionModal() {
    if (!this.userSessionModal) {
      this.userSessionModal = new UserSessionModal({
        el: '#user-session-modal',
        closeable: false,
      });

      this.userSessionModal.onRefresh(() => {
        this.updateTime();
        this.userSessionModal.close();
      });

      this.userSessionModal.onSessionExpired(() => {
        this.cleanWindowIntervals();
      });
    }

    return this.userSessionModal;
  }

  showModal() {
    if (!this.shouldDisplayModal()) {
      return;
    }

    this.getSessionModal().show();

    $('#modal-background').css({
      zIndex: 100,
    });
    $(document).off('click', '#modal-background');
    $(document).off('keyup');
  }

  cleanWindowIntervals() {
    window.clearInterval(window.userSession);
    window.userSession = undefined;
    window.clearInterval(window.checkUserActivity);
    window.checkUserActivity = undefined;
  }

  erase() {
    this.cleanWindowIntervals();
    window.localStorage.removeItem('user-session');
    window.localStorage.removeItem('user-session-warning');
  }
}
